import React, { useContext, useEffect, useState } from 'react';
import {
   Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, ButtonGroup,
   Col, Collapse, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table
} from 'reactstrap';
import { confirmAlert } from "react-confirm-alert";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import Switch from "react-switch";
import { toast } from "react-toastify";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { MdArrowRight, MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";
import _ from 'lodash';
import { ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, constants, dateHelpers, storage, UserContext } from '../utils';

const REMOVE_FAILED_MESSAGE = "The case could not be removed from the order. If this persists, contact a system admin.";

export default function SalesFulfillment() {
   const ICONS = {
      openEye: <AiFillEye className="mobileEyeToggle align-self-center" />,
      shutEye: <AiFillEyeInvisible className="mobileEyeToggle align-self-center" />,
      collapseIcon: <MdOutlineExpandLess className="mobileToggle align-self-center" />,
      expandIcon: <MdOutlineExpandMore className="mobileToggle align-self-center" />,
      arrowIcon: <MdArrowRight className="mobileToggleSmall align-self-center" />
   }
   const { currentUser } = useContext(UserContext);
   const [barcode, setBarcode] = useState(null);
   const [boxes, setBoxes] = useState(0);
   const [createUps, setCreateUps] = useState(false);
   const [data, setData] = useState({});
   const [expanded, setExpanded] = useState("0");
   const [loaded, setLoaded] = useState(true);
   const [lot, setLot] = useState("");
   const [manualEntry, setManual] = useState(null);
   const [open, setOpen] = useState(null);
   const [override, setOverride] = useState(null);
   const [part, setPart] = useState({});
   const [pass, setPass] = useState("");
   const [passwordType, setPasswordType] = useState("password");
   const [pCount, setPCount] = useState(0);
   const [printing, setPrinting] = useState(false);
   const [printPdf, setPrintPdf] = useState(false);
   const [qty, setQty] = useState(0);
   const [reprint, setReprint] = useState(false);
   const [showDetail, setShow] = useState(true);
   const [showPallet, setPallet] = useState(null);
   const [showPart, setShowPart] = useState(null);
   const [showUps, setShowUps] = useState(null);
   const [upsOrder, setUpsOrder] = useState({});
   const sleep = ms => new Promise(r => setTimeout(r, ms));
   let modalClassName = currentUser.theme ? `${currentUser.theme}` : "lightTheme";
   let savedDevice = JSON.parse(storage.getItem("deviceType"));
   const isMobile = savedDevice.isMobile;
   const hasScanner = savedDevice.hasScanner;

   useEffect(() => {
      inputFocus("searchInput");
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      // if device has built-in scanner see if a scan was completed
      if (barcode && hasScanner && !manualEntry) {
         setLoaded(false);
      }
      if (manualEntry)
         inputFocus("manualInput");
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [barcode])

   useEffect(() => {
      if (!loaded && barcode) {
         var bcType = constants.GetBarcodeType(barcode);
         if (bcType === constants.BARCODE_TYPE.SalesOrder) {
            getOrder(barcode);
         }
         else if (!data || !data.orderId || data.orderId === "") {
            toast.warning("Invalid barcode. Scan an order from the shipping schedule first.");
            setLoaded(true);
            setBarcode(null);
            inputFocus("searchInput");
         }
         else if (bcType === constants.BARCODE_TYPE.Inventory) {
            getCase();
         }
         else if (bcType === constants.BARCODE_TYPE.MachinePart) {
            getPart();
         }
         else {
            toast.warning("Invalid barcode. Scan an order from the shipping schedule first.");
            setLoaded(true);
            inputFocus("searchInput");
         }
      }
      else { // barcode is not usable so stop spinner
         if (!printing) { setLoaded(true); }
         setPrinting(false)
         setBarcode(null);
         inputFocus("searchInput");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded])

   useEffect(() => {
      // get password to remove a case or clear stuff
      if (lot?.length > 0) {
         setOverride(1);
      }
      else {
         setOverride(null);
         setReprint(false);
         setPasswordType("password");
         setPass("");
         inputFocus("searchInput");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [lot])

   useEffect(() => {
      if (manualEntry) {
         inputFocus("manualInput");
         return;
      }

      if (!barcode) {
         inputFocus("searchInput");
         return;
      }

      setLoaded(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [manualEntry])

   useEffect(() => {
      setLoaded(true);
      if (part?.itemNumber) {
         if (!showPart) {
            setShowPart(1);
            inputFocus("txtQty");
         }
         else {
            setPrinting(true)
            completePart();
         }
      }
      else {
         setShowPart(null);
         setQty(0);
         inputFocus("searchInput");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [part])

   function addBoxes() {
      setLoaded(false);
      api
         .post(`Mobile/AddUpsBoxes/`, upsOrder)
         .then(response => {
            if (response.data.success) {
               setUpsOrder(response.data.order);
            }
            else {
               toast.warning(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setLoaded(true);
         });
   }

   function cancelPart() {
      setPart({});
   }

   function changeBoxes(val) {
      let changes = Object.assign({}, upsOrder);
      changes["boxCount"] = val;
      setUpsOrder(changes);
      setBoxes(val);
   }

   function changeWgt(idx, val) {
      let newWgts = upsOrder.upsWgts.slice(); // copy the box array
      let targetItem = _.find(newWgts, w => w.boxId === idx); // find target box
      targetItem.wgt = val; // update box weight
      setUpsOrder({ // change state with new value
         ...upsOrder,
         upsWgts: newWgts
      });

      //let changes = Object.assign({}, upsOrder);
      //changes.upsWgts.forEach(bx => {
      //  if (bx.boxId === idx)
      //    bx.wgt = val;
      //});
      ////changes.upsWgts[idx-1].wgt = val;  // possible alternative?
      //setUpsOrder(changes);
   }

   function completePart() {
      setLoaded(false);
      if (printPdf) {
         api
            .postDownloadBinary(
               `Mobile/ApplyPartToOrder/`,
               part,
               constants.MIME_TYPES.pdf,
               `ShipLabel_${dateHelpers.getDateStringForReportName()}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
                  inputFocus("txtQty");
               }
               else {
                  setPart({});
                  getOrder(data.orderId);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               inputFocus("txtQty");
            });
      }
      else {
         api
            .post(`Mobile/ApplyPartToOrder/`, part)
            .then(response => {
               if (response.data.success) {
                  setPart({});
                  getOrder(data.orderId);
               }
               else {
                  toast.warning(response.data.message);
                  inputFocus("txtQty");
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               inputFocus("txtQty");
            });
      }
   }

   function deleteCase() {
      // loaded is false while a removal (or the order reload that follows it) is in flight.
      if (!loaded) return;
      var url = `Mobile/RemoveItemFromOrder/${data.orderId}/${lot}/${reprint}/${printPdf}`;
      var body = { password: pass };
      setLoaded(false);
      if (reprint && printPdf) {
         api
            .postDownloadBinary(
               url,
               body,
               constants.MIME_TYPES.pdf,
               `${lot}_${dateHelpers.getDateStringForReportName()}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               getOrder(data.orderId);
               setLot("");
            })
      }
      else {
         api
            .post(url, body)
            .then(response => {
               api.toastFailure(response, REMOVE_FAILED_MESSAGE);
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               getOrder(data.orderId);
               setLot("");
            })
      }
   }

   function doShipment(print) {
      if (upsOrder.createShipment === true) {
         setPrinting(true);
         makeShipment(print);
      }
      else if (print === true) {
         setShowUps(null);
         printSlip(); // only print packing slip
      }
   }

   function errorDialog(errorMsg) {
      // Show an in-your-face dialog instead of toast to force users to acknowledge it
      // If calls are added elsewhere and final actions are needed add them to the onClick method
      confirmAlert({
         title: "Error",
         message: `${errorMsg}`,
         buttons: [
            {
               label: "OK",
               onClick: () => {
                  setShowUps(null);  // if UPS segment is showing close it
               },
            },
         ],
      });
   }

   function getCase() {
      // If a QR code was scanned then parse out just the barcode from the data
      var code = constants.GetRealBarcode(barcode);
      var url = `Mobile/ApplyItemToOrder/${data.orderId}/${code}/${printPdf}`;
      if (printPdf) {
         api
            .postDownloadBinary(
               url,
               null,
               constants.MIME_TYPES.pdf,
               `ShipLabel_${dateHelpers.getDateStringForReportName()}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
                  setLoaded(true);
               }
               else {
                  getOrder(data.orderId);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               setLoaded(true);
            });
      }
      else {
         api
            .post(url)
            .then(response => {
               if (response.data.success) {
                  getOrder(data.orderId);
               }
               else {
                  toast.warning(response.data.message);
                  setLoaded(true);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               setLoaded(true);
            });
      }
   }

   function getOrder(orderId) {
      // reset some values
      setData({});
      setUpsOrder({});
      setPCount(0);
      setBoxes(0);
      setCreateUps(false);
      setReprint(false);

      api
         .post(`Mobile/LoadFulfillment/${orderId}`)
         .then(response => {
            if (response.data.success) {
               setUpsOrder(response.data.upsOrder);
               setData(response.data.model);
               setPCount(response.data.model.palletCount);
            }
            else {
               toast.warning(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setLoaded(true);
         });
   }

   function getPart() {
      var bc = constants.GetRealBarcode(barcode);
      api
         .post(`Mobile/ProcessPartBarcode/${data.orderId}/${bc}`)
         .then(response => {
            if (response.data.success) {
               response.data.model.printPdf = printPdf;
               setQty(response.data.model.qtyFulfilled);
               setPart(response.data.model);
            }
            else {
               toast.error(response.data.message);
               setPart({});
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setLoaded(true);
            inputFocus("searchInput");
         });
   }

   const handleFocus = (event) => event.target.select();

   const handleKeypress = e => {
      if (e.charCode === 13 || e.key === 'Enter') {
         setManual(null);
         return;
      }
      inputFocus("manualInput");
   };

   const handlePrint = nextChecked => {
      setPrintPdf(nextChecked);

      let changes = Object.assign({}, upsOrder);
      changes["printPdf"] = nextChecked;
      setUpsOrder(changes);

      inputFocus("searchInput");
   }

   async function inputFocus(fieldname) {
      await sleep(80);  // allows time for input to be recognized
      const el = document.querySelector(`input[name=${fieldname}]`);
      if (el !== null) {
         await el.focus();
      }
   }

   async function lookup(barcode) {
      setBarcode(barcode.toUpperCase());

      if (manualEntry) {
         inputFocus("manualInput");
         return;
      }
      inputFocus("searchInput");
   }

   function makeShipment(print) {
      setLoaded(false);
      if (printPdf) {
         api
            .postDownloadBinary(
               `Mobile/CreateShipment/`,
               upsOrder,
               constants.MIME_TYPES.pdf,
               `UpsLabel_${dateHelpers.getDateStringForReportName()}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  errorDialog(res.message);
                  setLoaded(true);
               }
               else {
                  setShowUps(null);
                  if (print === true) {
                     printSlip();
                  }
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               setLoaded(true);
            });
      }
      else {
         api
            .post(`Mobile/CreateShipment/`, upsOrder)
            .then(response => {
               if (response.data.success) {
                  setShowUps(null);
                  if (print === true) {
                     printSlip();
                  }
               }
               else {
                  errorDialog(response.data.message);
                  setLoaded(true);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               setLoaded(true);
            });
      }
   }

   function printSlip() {
      setPrinting(true)
      var url = `Mobile/PrintPackingSlip/${data.orderId}/${printPdf}`;
      setLoaded(false);
      if (printPdf) {
         api
            .postDownloadBinary(
               url,
               null,
               constants.MIME_TYPES.pdf,
               `PackSlip_${data.orderId}_${dateHelpers.getDateStringForReportName()}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               setPallet(null);
               setLoaded(true);
            });
      }
      else {
         api
            .post(url)
            .then(response => {
               if (response.data.success) {
                  toast.success("Please check the printer for your packing list.");
               }
               else {
                  toast.warning(response.data.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               setPallet(null);
               setLoaded(true);
            });
      }
   }

   function reprintCase(lotNum) {
      setPrinting(true)
      var url = `Mobile/ReprintShipLabel/${data.orderId}/${lotNum}/${printPdf}`;
      reprintLabel(url);
   }

   function reprintLabel(url) {
      setLoaded(false);
      if (printPdf) {
         api
            .postDownloadBinary(
               url,
               null,
               constants.MIME_TYPES.pdf,
               `ShipLabel_${dateHelpers.getDateStringForReportName()}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               setLoaded(true);
            });
      }
      else {
         api
            .post(url)
            .then(response => {
               if (response.data.success) {
                  toast.success("Please check the printer for your label(s).");
               }
               else {
                  toast.warning(response.data.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               setLoaded(true);
            });
      }
   }

   function reprintPart(item) {
      // escape the forward slash character or pound symbol if in the item so it won't mess up the URL
      // Example = MP.11/64S40007 this causes the url to look like it has an extra parameter because
      // of the / character so the URL is broken and a Not Found error is thrown.
      setPrinting(true)
      var encodedItem = item.replace(/\//g, '%2F').replace(/#/g, '%23');
      var url = `Mobile/ReprintPartShipLabel/${data.orderId}/${encodedItem}/${printPdf}`;
      reprintLabel(url);
   }

   function startPrintSlip() {
      if (pCount <= 0) {
         printSlip();
      }
      else {
         setPallet(1);
         inputFocus("txtPalletCount");
      }
   }

   const toggle = (idx) => {
      if (expanded === idx) {
         setExpanded();
      } else {
         setExpanded(idx);
      }
      inputFocus("searchInput");
   };

   const togglePassword = () => {
      // see the password yes/no ?
      if (passwordType === "password") {
         setPasswordType("text")
         return;
      }
      setPasswordType("password")
   }

   function toggleReprint() {
      setReprint(!reprint);
   }

   function toggleShow() {
      setShow(!showDetail);
      inputFocus("searchInput");
   }

   function toggleUps() {
      let changes = Object.assign({}, upsOrder);
      changes["createShipment"] = !createUps;
      setUpsOrder(changes);
      setCreateUps(!createUps);
   }

   function updatePalletCount(print) {
      if (!pCount || pCount <= 0) {
         toast.error("Pallet Count is required");
         inputFocus("txtPalletCount");
         return;
      }

      setLoaded(false);
      api
         .post(`Mobile/UpdatePalletCount/${data.orderId}/${data.palletItem}/${pCount}`)
         .then(response => {
            if (response.data.success) {
               setPallet(null);
               if (print === true) {
                  printSlip();
               }
               else {
                  setLoaded(true);
               }
            }
            else {
               toast.warning(response.data.message);
               setLoaded(true);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setLoaded(true);
         })
         .finally(() => {
            setLoaded(true);
         });
   }

   function validatePart() {
      // Changes to the part qty fulfilled
      if (qty === 'undefined' || qty === null) {
         toast.error('Quantity fulfilled is required.');
         inputFocus("txtQty");
         return;
      }

      if (qty > part.origQtyFulfilled + part.qtyAvail) {
         toast.error('Quantity fulfilled cannot exceed the quantity available.');
         inputFocus("txtQty");
         return;
      }

      if (qty > part.qtyOrdered) {
         toast.error('Quantity fulfilled cannot exceed the order quantity.');
         inputFocus("txtQty");
         return;
      }

      let changes = Object.assign({}, part);
      changes["qtyFulfilled"] = qty;
      setPart(changes);
   }


   return (
      <>
         <DesktopContainer screenName="Sales Fulfillment">
            <ServiceThreadSpinner on={!loaded}>
               <Row><Col className="h6 fw-bold" xs="12">Scan a shipping schedule barcode</Col></Row>
               <Row><Col><hr className="mb-0 my-1" /></Col></Row>
               <br />
               {!hasScanner && isMobile ?
                  <div>
                     <Row className="justify-content-center">
                        <Col xs="12">
                           <Button
                              title="scan entry"
                              className="shredButton w-100 btn-md"
                              onClick={() => setOpen(1)}>
                              Scan Barcode
                           </Button>
                        </Col>
                     </Row>
                     <Row className="lineheight8">&nbsp;</Row>
                  </div>
                  : null
               }
               <div>
                  <Row className="justify-content-center">
                     <Col xs="12">
                        <Button
                           title="manual entry"
                           className="shredButton w-100 btn-md"
                           onClick={() => setManual(1)}>
                           Manual Entry
                        </Button>
                     </Col>
                  </Row>
                  {isMobile ?
                     <div>
                        <Row className="lineheight8">&nbsp;</Row>
                        <Row className="justify-content-center">
                           <Col xs="12">
                              <Input
                                 name="searchInput"
                                 placeholder="Focus here to scan barcode"
                                 className="h-100"
                                 onChange={(e) => lookup(e.target.value)}
                              />
                           </Col>
                        </Row>
                     </div>
                     : null
                  }
               </div>
               <br />

               {data && data.orderId ?
                  <div>
                     {/* Show Print PDF Switch on large devices */}
                     {!isMobile ?
                        <Row>
                           <Col className="h6 fw-bold" xs="12">
                              <label>
                                 <span className="my-1">&nbsp; &nbsp; &nbsp; &nbsp; {printPdf ? "Download as PDF" : "Print to printer"}  </span>
                                 <Switch
                                    onChange={handlePrint}
                                    checked={printPdf}
                                    className="react-switch"
                                 />
                              </label>
                           </Col>
                        </Row>
                        : null
                     }

                     <Button color="primary" outline onClick={toggleShow} className="mx-0 w-100 fw-bold">
                        Sales Order: {data.orderId}
                     </Button>
                     <Collapse className="mx-0 py-0 px-0" isOpen={showDetail}>
                        {data.lineItems?.length > 0 ?
                           <div>
                              <Accordion open={expanded} toggle={toggle}>
                                 {_.map(data.lineItems, (item, index) => {
                                    return (
                                       <div details={item} key={index} >
                                          {!item.isPallet ?
                                             <AccordionItem className={(index % 2 === 0) ? "mobileBlueBg text-white my-0 py-1 px-1" : "mobileBlueBgAlt text-white my-0 py-1 px-1"}>
                                                <AccordionHeader targetId={String(index)}>
                                                   {item.nodeDesc}<br />{item.itemNumber}<br />Bin: {item.bin}
                                                </AccordionHeader>

                                                <AccordionBody accordionId={String(index)} className="py-1 px-0">
                                                   {item.isMachinePart ?
                                                      <div>
                                                         <Button children="Reprint Label" className="btn btn-sm px-1 py-0" onClick={() => {
                                                            reprintPart(item.itemNumber);
                                                         }} />
                                                      </div>
                                                      : null
                                                   }

                                                   {item.isLotTrackedItem && item.cases?.length <= 0 ?
                                                      <div>
                                                         {ICONS.arrowIcon} No Lots Found
                                                      </div>
                                                      : null
                                                   }

                                                   {item.cases?.length > 0 ?
                                                      <div>
                                                         {_.map(item.cases, (c, idx) => {
                                                            return (
                                                               <div details={c} key={idx} className="py-1 px-0">
                                                                  {ICONS.arrowIcon} {c.lot}<br />
                                                                  <Button children="Reprint Label" className="btn btn-sm px-1 py-0" onClick={() => {
                                                                     reprintCase(c.lot);
                                                                  }} />
                                                                  &nbsp;&nbsp;
                                                                  <Button children="Remove" className="btn btn-sm px-1 py-0" onClick={() => {
                                                                     setLot(c.lot);
                                                                  }} />
                                                               </div>
                                                            )
                                                         })}
                                                      </div>
                                                      : null
                                                   }
                                                </AccordionBody>
                                             </AccordionItem>
                                             : null
                                          }
                                       </div>
                                    )
                                 })}
                              </Accordion>
                           </div>
                           : null
                        }
                     </Collapse>
                     <br />
                     {/* UPS Order Requirements and Print Buttons */}
                     {data.isUpsOrder ?
                        <div>
                           <Button children="Ship & Print PL" className="btn-md shredButtonLower w-100" onClick={() => {
                              setShowUps(1);
                           }} />
                        </div>
                        : null
                     }

                     {/* Print Packing Slip Button */}
                     {!data.isUpsOrder ?
                        <div>
                           <Button children="Print PL" className="btn-md shredButtonLower w-100" onClick={() => {
                              startPrintSlip();
                           }} />
                        </div>
                        : null
                     }

                  </div>
                  : null
               }

               {/* UPS Order Create Shipment, Add Boxes, Save and CLose, or Save and Print */}
               <Modal isOpen={showUps !== null} contentClassName={modalClassName}>
                  <ModalHeader className="mobileBlueBg text-white" children="UPS Order" />
                  <ModalBody className="mobileBlueBgAlt text-white"
                     children={
                        <div>
                           <p className="h6">This order is set to be shipped via UPS. Check the box below to create and print UPS shipping labels.</p>
                           <div className="input-group">
                              <label className="text-white h6">
                                 <input type="checkbox"
                                    checked={createUps}
                                    className="me-2"
                                    onChange={() => toggleUps()} />
                                 Create UPS Shipment?
                              </label>
                           </div>
                           <br />
                           <p className="h6">Enter number of UPS boxes shipping for non-lot-tracked items:</p>
                           <div className="input-group">
                              <Input
                                 name="txtBoxCount"
                                 type="number"
                                 value={boxes}
                                 className="h-100"
                                 onFocus={handleFocus}
                                 onChange={(e) => { changeBoxes(e.target.value) }}
                                 placeholder="Enter Box Count ..."
                              />
                           </div>
                           <div className="input-group">
                              <Button
                                 className="shredButton w-50 btn-md my-3"
                                 onClick={() => {
                                    addBoxes();
                                 }}>
                                 Add
                              </Button>
                           </div>
                           <br />
                           {upsOrder && upsOrder.boxCount > 0 && upsOrder.upsWgts?.length > 0 ?
                              <div>
                                 <p className="h6">Enter the shipping weight in LBS for each box</p>
                                 {_.map(upsOrder.upsWgts, (bx, idx) => {
                                    return (
                                       <div details={bx} key={idx} className="py-1 px-0">
                                          <p className="h6">Box {bx.boxId} Weight in LBS</p>
                                          <div className="input-group">
                                             <Input
                                                type="number"
                                                value={bx.wgt}
                                                className="h-100"
                                                onFocus={handleFocus}
                                                onChange={(e) => { changeWgt(bx.boxId, e.target.value) }}
                                                placeholder="Enter Box Weight ..."
                                             />
                                          </div>

                                       </div>
                                    )
                                 })}
                              </div>
                              : null
                           }
                           <br />
                           <Row>
                              <Col xs="12">
                                 <Button
                                    className="shredButton w-100 btn-md"
                                    onClick={() => {
                                       doShipment(true);
                                    }}>
                                    Save & Print PL
                                 </Button>
                              </Col>
                           </Row>
                           <Row className="lineheight8">&nbsp;</Row>
                           <Row>
                              <Col xs="12">
                                 <Button
                                    className="shredButton w-100 btn-md"
                                    onClick={() => {
                                       doShipment(false);
                                    }}>
                                    Save & Close
                                 </Button>
                              </Col>
                           </Row>
                           <Row className="lineheight8">&nbsp;</Row>
                           <Row>
                              <Col xs="12">
                                 <Button
                                    className="btn w-100 btn-md my-3"
                                    onClick={() => {
                                       changeBoxes(0);
                                       setShowUps(null);
                                    }}>
                                    Cancel
                                 </Button>
                              </Col>
                           </Row>
                        </div>
                     }
                  />
               </Modal>


               {/* Manual Barcode Entry */}
               <Modal isOpen={manualEntry !== null} contentClassName={modalClassName}>
                  <ModalHeader children="Enter Barcode" />
                  <ModalBody
                     children={
                        <Input
                           name="manualInput"
                           placeholder="Enter barcode"
                           className="h-100"
                           onChange={(e) => lookup(e.target.value)}
                           onKeyPress={handleKeypress}
                        />
                     }
                  />
                  <ModalFooter>
                     <ButtonGroup>
                        <Button children="Retrieve" className="button-success" onClick={() => {
                           setManual(null);
                        }} />
                        <Button children="Cancel" className="button-danger" onClick={() => {
                           setBarcode(null);
                           setManual(null);
                        }} />
                     </ButtonGroup>
                  </ModalFooter>
               </Modal>


               {/* Barcode Scan with Camera */}
               <Modal isOpen={open !== null} contentClassName={modalClassName}>
                  <ModalHeader children="Scan a Barcode" />
                  <ModalBody
                     children={
                        <BarcodeScannerComponent
                           height={350}
                           width={350}
                           onUpdate={(err, result) => {
                              if (result) {
                                 setBarcode(result.text.toUpperCase());
                                 setOpen(null);
                                 setLoaded(false);
                                 inputFocus("searchInput");
                              }
                              else {
                                 setBarcode(null);
                              }
                           }}
                           // onError={(err) => console.error("error", err)}
                           facingMode={"environment"}
                        />
                     }
                  />
                  <ModalFooter>
                     <Button
                        className="shredButton ms-7"
                        onClick={() => {
                           setOpen(null);
                           inputFocus("searchInput");
                        }}>Cancel
                     </Button>
                  </ModalFooter>
               </Modal>


               {/* Enter Override Password to Delete a Case */}
               <Modal isOpen={override !== null} contentClassName={modalClassName}>
                  <ModalHeader className="mobileBlueBg text-white" children="Enter Password" />
                  <ModalBody className="mobileBlueBgAlt text-white"
                     children={
                        <div>
                           <div className="input-group">
                              <Input
                                 name="pswd"
                                 type={passwordType}
                                 value={pass}
                                 className="h-100"
                                 onFocus={handleFocus}
                                 onChange={(e) => { setPass(e.target.value) }}
                                 placeholder="Enter Password ..."
                              />
                              <div className="input-group-btn">
                                 <button className="btn btn-md" onClick={togglePassword}>
                                    {passwordType === "password" ? ICONS.shutEye : ICONS.openEye}
                                 </button>
                              </div>
                           </div>
                           <br />
                           <label className="h6"><input type="checkbox" checked={reprint} className="me-2" onChange={() => toggleReprint()} />Reprint Inventory Label</label>
                           <div>
                           </div>
                           <Row>
                              <Col xs="6">
                                 <Button
                                    className="shredButton w-100 btn-md my-3"
                                    disabled={!loaded}
                                    onClick={() => {
                                       if (pass?.length < 1) {
                                          toast.error("Password is required");
                                          return;
                                       }
                                       deleteCase();
                                    }}>
                                    OK
                                 </Button>
                              </Col>
                              <Col xs="6">
                                 <Button
                                    className="btn w-100 btn-md my-3"
                                    onClick={() => {
                                       setLot("");
                                    }}>
                                    Cancel
                                 </Button>
                              </Col>
                           </Row>
                        </div>
                     }
                  />
               </Modal>


               {/* Enter Part Fulfilled Quantity */}
               <Modal isOpen={showPart !== null} contentClassName={modalClassName}>
                  <ModalHeader className="mobileBlueBg text-white" children="Enter Part Quantity" />
                  <ModalBody className="mobileBlueBgAlt text-white"
                     children={
                        <Table borderless size="sm">
                           <tbody>
                              <tr>
                                 <td className="data-cell my-0 py-0">
                                    <label className="h6 text-white fw-bold my-0">{part.itemNumber}</label>
                                 </td>
                              </tr>
                              <tr>
                                 <td className="data-cell my-0 py-0">
                                    <label className="h6 text-white fw-bold my-0">{part.itemDescription}</label>
                                 </td>
                              </tr>
                              <tr><td className="data-cell m-0 p-0 lineheight8">&nbsp;</td></tr>
                              <tr>
                                 <td className="data-cell my-0 py-0">
                                    <label className="h6 text-white my-0">Order Qty: {part.qtyOrdered ? part.qtyOrdered.toLocaleString("en-US", { maximumFractionDigits: 0 }) : "0"}</label>
                                 </td>
                              </tr>
                              <tr>
                                 <td className="data-cell my-0 py-0">
                                    <label className="h6 text-white my-0">Qty Available: {part.qtyAvail ? part.qtyAvail.toLocaleString("en-US", { maximumFractionDigits: 0 }) : "0"}</label>
                                 </td>
                              </tr>
                              <tr>
                                 <td className="data-cell my-0 py-0">
                                    <label className="h6 text-white my-0">Qty Remaining: {part.qtyBackOrdered ? part.qtyBackOrdered.toLocaleString("en-US", { maximumFractionDigits: 0 }) : "0"}</label>
                                 </td>
                              </tr>
                              {part.qtyExceeded ?
                                 <tr>
                                    <td className="data-cell my-0 py-0">
                                       <label className="text-brightRed h6 my-1">The quantity ordered exceeds the quantity available!</label>
                                    </td>
                                 </tr>
                                 : null
                              }
                              <tr><td className="data-cell m-0 p-0 lineheight8">&nbsp;</td></tr>
                              <tr>
                                 <td className="data-cell my-0 py-0">
                                    <label className="h6 text-white my-0">Total Qty Fulfilled:</label>
                                 </td>
                              </tr>
                              <tr>
                                 <td className="data-cell my-0 py-0">
                                    <Input
                                       name="txtQty"
                                       type="number"
                                       value={qty}
                                       className="h-100"
                                       onFocus={handleFocus}
                                       onChange={(e) => { setQty(e.target.value) }}
                                       placeholder="Enter fulfilled qty ..."
                                    />
                                 </td>
                              </tr>
                              <tr><td className="data-cell m-0 p-0 lineheight8">&nbsp;</td></tr>
                              <tr>
                                 <td className="data-cell my-0 mx-0 p-0">
                                    <Button
                                       className="shredButton w-100 btn-md my-0"
                                       onClick={() => {
                                          validatePart()
                                       }}>
                                       OK
                                    </Button>
                                 </td>
                              </tr>
                              <tr>
                                 <td className="data-cell my-0 mx-0 p-0">
                                    <Button
                                       className="btn w-100 btn-md mt-2 mb-0"
                                       onClick={() => {
                                          cancelPart()
                                       }}>
                                       Cancel
                                    </Button>
                                 </td>
                              </tr>
                           </tbody>
                        </Table>
                     }
                  />
               </Modal>


               {/* Enter Pallet Count */}
               <Modal isOpen={showPallet !== null} contentClassName={modalClassName}>
                  <ModalHeader className="mobileBlueBg text-white" children="Pallet Count" />
                  <ModalBody className="mobileBlueBgAlt text-white"
                     children={
                        <div>
                           <p className="h6 fw-bold">Enter the number of pallets shipping with this order.</p><br />
                           <div className="input-group">
                              <Input
                                 name="txtPalletCount"
                                 type="number"
                                 value={pCount}
                                 className="h-100"
                                 onFocus={handleFocus}
                                 onChange={(e) => { setPCount(e.target.value) }}
                                 placeholder="Enter Pallet Count ..."
                              />
                           </div>
                           <br />
                           <Row>
                              <Col xs="12">
                                 <Button
                                    className="shredButton w-100 btn-md my-3"
                                    onClick={() => {
                                       updatePalletCount(true);
                                    }}>
                                    Save & Print PL
                                 </Button>
                              </Col>
                           </Row>
                           <Row className="lineheight8">&nbsp;</Row>
                           <Row>
                              <Col xs="12">
                                 <Button
                                    className="shredButton w-100 btn-md my-3"
                                    onClick={() => {
                                       updatePalletCount(false);
                                    }}>
                                    Save & Close
                                 </Button>
                              </Col>
                           </Row>
                           <Row className="lineheight8">&nbsp;</Row>
                           <Row>
                              <Col xs="12">
                                 <Button
                                    className="btn w-100 btn-md my-3"
                                    onClick={() => {
                                       setPallet(null);
                                    }}>
                                    Cancel
                                 </Button>
                              </Col>
                           </Row>
                        </div>
                     }
                  />
               </Modal>

            </ServiceThreadSpinner>
         </DesktopContainer >
      </>
   );
}
